/* eslint-disable react/display-name */
import React, { FC, FunctionComponent } from "react"
import { observer } from "mobx-react-lite"

import { SwipeListView } from 'react-native-swipe-list-view';
import MapView, { Marker } from 'react-native-maps';
import { View, Text, AppState, Linking, Platform, ScrollView, Pressable, StyleSheet } from "react-native"
import { glueStyles } from '../../../app/configGlueStack/gluestack-ui.config';

import {
   Button, Icon,
} from "native-base"
import Spacer from "../../components/base/Spacer"


import {
  StatusBar, Badge, BadgeText,
  Button as Button2, Box,
  ButtonIcon, VStack, HStack,
  Input,
  InputSlot,
  InputIcon,
  SearchIcon, GripVerticalIcon,
  InputField,
  Actionsheet,
  ActionsheetContent, ActionsheetDragIndicatorWrapper, ActionsheetDragIndicator,
  ActionsheetItem, ActionsheetBackdrop,
  ActionsheetItemText,
  ActionsheetIcon,
} from "@gluestack-ui/themed";

import { MaterialIcons, Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";

import { HomeStackParamList, useBackButtonHandler } from "../../navigators"
import { DrawerScreenProps } from "@react-navigation/drawer"
import { useStores } from "../../models"
import { ITEM_STATUS } from "../../voolks/types";
import { getIconItem, getItemTitle, openPDF, getIconItemPTW, getGPSCoords } from "../../utils/itemCommonFunctions";

import * as Storage from "../../utils/storage";

import { DateTimePicker, ModalIconInfo, ModalInfo, ModalInfoProps } from "../../components";
import { RNPicker } from "../../components/base/RNPicker";



// Este componente está fuera de PTWHomeScreen
const ItemRow = React.memo(({ item, department, form, onPress, isSwiping, currentStateOnly }: any) => {
  // Usamos View nativo para la estructura base para ganar velocidad
  item.stepNumber= item.stepNumber || 0;
  return (
    <View style={styles.itemContainer}>
      <View style={styles.innerRow}>
        {getIconItem(item.status)}
        <View style={styles.contentWrapper}>
          <Pressable onPress={() => onPress(form, department, item)} disabled={isSwiping}>
            <View style={styles.titleRow}>
              <Text style={styles.itemTitle}>{item.title}</Text>
              {getIconItemPTW(item.statusPTW)}
            </View>
            <View style={styles.subInfoRow}>
              <Text style={styles.subText}>
                {form.name} {item.stepNumber + 1}/{form.workflow.steps.length + 1} ......
              </Text>
              <View style={styles.stepsContainer}>
              {form.workflow.steps.map((step, idx) => {
                const isCurrentStep = item.stepNumber === idx;
                const isPastStep = item.stepNumber > idx;
                const shouldHideInMobile = currentStateOnly && !isCurrentStep;

                if (shouldHideInMobile) return null;

                return (
                <View key={`step-${idx}`} style={styles.stepWrapper}>
                    {!currentStateOnly && (
                      <Ionicons 
                        name="arrow-forward" 
                        size={12} 
                        color={glueStyles.colors.light400} 
                        style={styles.stepArrow} 
                      />
                    )}
                    <View style={[
                      styles.stepBadge,
                      isCurrentStep ? styles.stepCurrent : (isPastStep ? styles.stepSuccess : styles.stepPending)
                    ]}>
                      <Text style={[
                        styles.stepText,
                        isCurrentStep && styles.stepTextActive
                      ]}>
                        {step.name || idx + 2}
                      </Text>
                    </View>
                  </View>
                );
              }
              )}
              </View>
            </View>
          </Pressable>
        </View>
        <Spacer />
        <Pressable onPress={() => onPress(form, department, item)}>
          <Icon name="arrow-forward" as={Ionicons} size="md" color="light.400" />
        </Pressable>
      </View>
    </View>
  );
}, (prev, next) => {
  // Solo re-renderizar si cambian propiedades críticas
  return (
    prev.item.status === next.item.status &&
    prev.item.statusPTW === next.item.statusPTW &&
    prev.item.stepNumber === next.item.stepNumber &&
    prev.item.title === next.item.title &&
    prev.isSwiping === next.isSwiping
  );
});

const HiddenActions = React.memo(({ item, form, department, onClone, onPDF, onRemove }: any) => {
  return (
    <View style={styles.hiddenActionWrapper}>
      <View style={styles.actionGroup}>
        <Pressable
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.violet500 }]} // violet500
          onPress={() => onClone(form, department, item)}
        >
          <Ionicons name="copy" size={22} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.success500 }]} // success500
          onPress={() => onPDF(item)}
        >
          <FontAwesome5 name="file-pdf" size={20} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.yellow500 }]} // yellow500
          onPress={() => onPDF(item, true)}
        >
          <Ionicons name="mail" size={22} color="#FFF" />
        </Pressable>
      </View>

      <Spacer />

      <Pressable
        style={[styles.actionButton, { backgroundColor: glueStyles.colors.danger500 }]} // danger500
        onPress={() => onRemove(department, form, item)}
      >
        <Ionicons name="trash-outline" size={22} color="#FFF" />
      </Pressable>
    </View>
  );
});

export const PTWHomeScreen: FC<DrawerScreenProps<HomeStackParamList, "ItemsList">> = observer(function PTWHomeScreen({ navigation, route }) {
  const fcName = "PTWHomeScreen";
  console.log(fcName);
  const [isSwiping, setIsSwiping] = React.useState(false);
  const { formsStore, itemsStore, statusStore, authenticationStore } = useStores();
  const user = authenticationStore.userInfo.user;
  const [alertDialog, setAlertDialog] = React.useState<ModalInfoProps["alertDialog"]>(undefined);
  const [showIconInfo, setShowIconInfo] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [filterDateJob, setFilterDateJob] = React.useState(undefined);
  const [filterForm, setFilterForm] = React.useState({ id: undefined, name: "" });
  const [filterAutonumeric, setFilterAutonumeric] = React.useState(undefined);

  const [itemsPending, setItemsPending] = React.useState<boolean | undefined>(undefined);
  const [mustSync, setMustSync] = React.useState<boolean | undefined>(false);
  const [selectNewForm, setSelectNewForm] = React.useState<boolean | undefined>(false);
  const [filterView, setFilterView] = React.useState<boolean | undefined>(false);

  const [myLocation, setMyLocation] = React.useState<{ latitude: number, longitude: number }>({ latitude: -34.939, longitude: -58.497 });
  const currentStateOnly = statusStore.windowDimensions.width < 900;
  const swipeRows: any[] = [];

  let my_items: any = [];
  let departments: any = [];
  React.useEffect(() => {
    getGPSCoords().then((gps: any) => {
      if (gps)
        setMyLocation({ latitude: gps.coords.latitude, longitude: gps.coords.longitude });
    });
    checkMustSync();
    const listener = AppState.addEventListener("change", checkMustSync);
    return () => {
      listener.remove();
    }
  }, [])

  const handleSearch = (text: string) => {
    setSearch(text);
    console.log(text);
  }

  const leftButton = <Button2 width={50} height={50} p="$1" variant="solid" key="ptwHome_openDrawer" 
      onPress={navigation.openDrawer}>
        <ButtonIcon as={MaterialIcons} name="menu" fontWeight="$extrabold" size="xl" color="#FFF" />
      </Button2>

  const goBack = () => null

  useBackButtonHandler(goBack);

  const _openItem = async (form, department, itemSelected: any = undefined) => {
    console.log(fcName, "_openItem", "Init");
    if (itemSelected)
      await itemsStore.activateItem(itemSelected)
    if (itemsStore.itemActiveIDX != undefined) {
      await itemsStore.makePayloadFromFormPages(form.pages);
      navigation.navigate("ItemDetails", {
        itemStartedAt: new Date().getTime(),
        formId: form.id,
        deptId: department.id,
        forReview: itemsStore.itemActive.status != ITEM_STATUS.draft.toString(),
        taskId: undefined,
        pageActive: 0,
        rnd: new Date().getTime()
      })
    }
    console.log(fcName, "_openItem", "Fin");
  }

  const newItem = async (department, form) => {
    await itemsStore.new(form, undefined)
    _openItem(form, department);
  };
  const cloneItem = async (form, department, itemSelected: any = undefined) => {
    await itemsStore.new(form, undefined, itemSelected);
    _openItem(form, department);
  }

  const openItem = async (form, department, itemSelected: any = undefined) => {
    _openItem(form, department, itemSelected);
  }

  const removeItemsDialog = async (department, form, item: any = undefined) => {
    let lstIdx: number[] = [];
    let alert = { title: "", message: "" };
    if (item != undefined) {
      let itemIdx: number = itemsStore.getIDXofItem(item)
      if (itemIdx > -1) {
        lstIdx.push(itemIdx);
      }
      alert.title = `Borrar registro ${form.name}`;
      alert.message = `¿Estas seguro de borrar el registro  ${getItemTitle(form, item)}?`;
      setAlertDialog({
        ...alert,
        action: () => {
          swipeRows.map(async (row) => {
            await row?.closeRow();
          });
          lstIdx.sort((a, b) => { return b - a; }).forEach(idx => itemsStore.removeItem(idx));
        }
      })
    }
  }

  const checkMustSync = async () => {
    setMustSync((await Storage.getItem("must_sync")) != undefined);
    console.log(mustSync)
  }

  const renderItem = React.useCallback(
    (data, rowMap) => {
      const _maxWidth = statusStore.windowDimensions.width - (currentStateOnly ? 140 : 300);
      const item = data.item;
      const idx = data.index;
      const department = departments.find((dept: any) => dept.id === item.deptId);
      const form = department?.forms?.find((f: any) => f.id === item.formId);
      if (!department || !form) return <></>;

      let _title = item.title;
      if (_title === undefined || _title.trim() === "") {
        _title = getItemTitle(form, item);
        item.title = _title;
      }
      if (search.trim().length > 0 && !(_title?.toUpperCase()?.includes(search.toUpperCase()) || form.name.toUpperCase()?.includes(search.toUpperCase())))
        return <></>;
      if (item.statusPTW == "finished" && item.stepNumber > form.workflow.steps_approved && item.stepNumber < form.workflow.steps.length)
        item.statusPTW = "closing"
      return (
        <ItemRow
          item={item}
          department={department}
          form={form}
          onPress={openItem}
          isSwiping={isSwiping}
          statusStore={statusStore}
          currentStateOnly={currentStateOnly}
        />
      );

    }
    ,
    [departments]);

  const renderHiddenItem = React.useCallback((data, rowMap) => {
    const item = data.item;
    const department = departments.find((dept: any) => dept.id === item.deptId);
    const form = department?.forms?.find((f: any) => f.id === item.formId);

    if (!department || !form) return  <></>;

    return (
      <HiddenActions
        item={item}
        form={form}
        department={department}
        onClone={cloneItem}
        onPDF={(it, mail) => openPDF(itemsStore, it, mail)}
        onRemove={removeItemsDialog}
      />
    );
  }, [departments]);

  const ItemsListRows: FunctionComponent = () => {
    return (
      <SwipeListView
        useFlatList={true} windowSize={10} removeClippedSubviews={true} initialNumToRender={15}
        onSwipeValueChange={({ value }) => {
          if (value !== 0) setIsSwiping(true); // Detecta swipe activo
          else setIsSwiping(false); // Resetea al finalizar el swipe
        }}
        data={my_items} style={{ width: "100%" }}
        renderItem={renderItem}
        leftOpenValue={170}
        rightOpenValue={-60}
        renderHiddenItem={renderHiddenItem}
      />
    )
  }


  const someToUpload =
    my_items.reduce((counter, item) => {
      return counter + (item.status == ITEM_STATUS.closed ? 1 : 0)
    }, 0);
  const svgMarkerUser = {
    path: "M375.935,375.033c-10.498-5.408-22.442-10.275-35.512-14.472c-0.767-0.409-2.272-1.216-4.303-2.33 c-16.668-9.184-29.807-17.867-36.12-23.803v-24.286c30.385-17.372,51.163-48.542,57.804-86.695 C375.017,218.518,390,202.361,390,187.5c0-15.043-11.308-25.026-30-27.094V150h35v-7.5c0-9.655-8.382-46.807-27.002-47.469 C355.397,57.703,326.775,27.87,290,13.748V0h-95v13.748c-36.824,14.137-65.464,43.973-78.033,81.285 C98.372,95.74,90,132.851,90,142.5v7.5h35v10.406c-18.692,2.068-30,12.051-30,27.094c0,14.861,14.983,31.019,32.196,35.948 c6.647,38.167,27.429,69.336,57.804,86.695v24.285c-6.312,5.936-19.45,14.618-36.106,23.795c-2.06,1.13-3.577,1.943-4.338,2.349 c-13.408,4.401-25.363,9.341-35.485,14.658c-62.571,32.182-64.037,75.318-64.069,77.139L45,485h395v-32.537 C439.991,450.626,439.051,407.119,375.935,375.033z M340,376.218c9.011,3.058,17.38,6.448,25,10.127V430h-25V376.218z M375,187.5 c0,6.126-6.627,14.467-15.266,19.07c0.165-2.964,0.266-31.088,0.266-31.088C373.367,177.356,375,184.268,375,187.5z M290,29.958 C318.457,42.536,340.807,65.964,352.045,95H290V29.958z M210,15h65v80h-65V15z M195,29.956V95h-62.081 C144.134,65.976,166.5,42.545,195,29.956z M110,187.5c0-3.232,1.633-10.144,15-12.018c0,0,0.101,28.125,0.266,31.088 C116.627,201.966,110,193.626,110,187.5z M105.912,135c2.285-10.771,8.315-23.686,11.757-25h249.662 c3.442,1.314,9.472,14.229,11.757,25H105.912z M141.227,216.156C140.413,210.366,140,204.09,140,197.5V150h205v47.5 c0,6.59-0.413,12.866-1.229,18.674c-5.158,37.347-25.101,67.55-54.733,82.874C275.075,306.315,259.417,310,242.5,310 s-32.575-3.685-46.555-10.962C166.331,283.724,146.388,253.521,141.227,216.156z M285,317.299v17.312 C279.87,339.974,263.613,355,242.5,355c-20.977,0-37.346-15.055-42.5-20.404v-17.298c13.182,5.108,27.424,7.702,42.5,7.702 C257.579,325,271.824,322.405,285,317.299z M160,369.204c9.754-5.509,23.203-13.621,32.241-21.169 C200.885,356.174,219.023,370,242.5,370s41.615-13.826,50.259-21.966c9.035,7.546,22.48,15.656,32.241,21.169V430H160V369.204z M120,386.509c7.426-3.641,15.798-7.078,25-10.258V430h-25V386.509z M90.2,470H60v-17.37c0.093-2.065,2.189-31.708,45-57.922 V430.2c-8.466,1.22-15,8.502-15,17.3v20C90,468.351,90.082,469.181,90.2,470z M380,467.5c0,1.355-1.145,2.5-2.5,2.5h-270 c-1.355,0-2.5-1.145-2.5-2.5v-20c0-1.355,1.145-2.5,2.5-2.5h270c1.355,0,2.5,1.145,2.5,2.5V467.5z M425,470h-30.2 c0.118-0.819,0.2-1.649,0.2-2.5v-20c0-8.798-6.534-16.081-15-17.3v-35.764c43.445,26.306,44.951,56.392,45,58.136V470z",
    fillColor: "green",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "green",
    rotation: 0,
    scale: 0.05
  };

  const svgMarkerWarning = {
    path: "M108.186,144.372c0,7.054-4.729,12.32-12.037,12.32h-0.254c-7.054,0-11.92-5.266-11.92-12.32 c0-7.298,5.012-12.31,12.174-12.31C103.311,132.062,108.059,137.054,108.186,144.372z M88.44,125.301h15.447l2.951-61.298H85.46 L88.44,125.301z M190.372,177.034c-2.237,3.664-6.214,5.921-10.493,5.921H12.282c-4.426,0-8.51-2.384-10.698-6.233 c-2.159-3.849-2.11-8.549,0.147-12.349l84.111-149.22c2.208-3.722,6.204-5.96,10.522-5.96h0.332 c4.445,0.107,8.441,2.618,10.513,6.546l83.515,149.229C192.717,168.768,192.629,173.331,190.372,177.034z M179.879,170.634 L96.354,21.454L12.292,170.634H179.879z",
    fillColor: "orange",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "orange",
    rotation: 0,
    scale: 0.15
  };

 
  if (statusStore.status == "pending")
    return (<></>);


  const mySubscriptions = formsStore.mySubscriptions();
  let lstForms: object[] = [];
  departments = mySubscriptions.subscriptions.reduce((lst, dept) => {
    const wfs = [];
    for (const form of dept.forms) {
      if (form.type == "ptw")
        wfs.push(form)
    }
    if (wfs.length > 0) {
      lst.push({ "id": dept.id, "name": dept.name, forms: wfs })
      lstForms = lstForms.concat(wfs)
    }
    return lst;
  }, []);

  if (itemsPending == undefined) {
    my_items = itemsStore.myItems().reverse().filter(item => {
      const department = departments.find((dept: any) => dept.id == item.deptId);
      if (department == undefined)
        return false;
      const form = (department.forms || []).find((form: any) => form.id == item.formId);
      if (form == undefined)
        return false;

      let dateJob;
      if (form.workflow.scheduledDate && item.payload.get(form.workflow.scheduledDate)) {
        dateJob = new Date(item.payload.get(form.workflow.scheduledDate).value);
      }
      if (dateJob == undefined || isNaN(dateJob.getTime()))
        dateJob = item._startedAt;
      if (dateJob && dateJob.toISOString().substring(0, 10) != (new Date()).toISOString().substring(0, 10))
        return false
      return true;

    }).sort((a, b) => a.status.localeCompare(b.status));
  } else
    my_items = itemsStore.myItems().reverse().filter(item => (!itemsPending || item.status != "sent" || item.statusPTW == "waiting")).sort((a, b) => a.status.localeCompare(b.status));
  let qFilterToApply = 0;
  qFilterToApply += (filterAutonumeric != undefined && filterAutonumeric.trim() != "") ? 1 : 0;
  qFilterToApply += (filterForm.id != undefined) ? 1 : 0;
  qFilterToApply += (filterDateJob != undefined && filterDateJob.trim() != "") ? 1 : 0;
  if (qFilterToApply > 0) {
    my_items = my_items.filter(item => {
      let applied = 0;
      const f = lstForms.find(f => f.id == item.formId);
      if (filterAutonumeric != undefined && filterAutonumeric.trim() != "") {
        let autonumericField = f.pages[0].fields.find(f => f.type == "autonumeric");
        if (autonumericField && item.payload.get(autonumericField.id).value == filterAutonumeric.trim())
          applied += 1;
      }
      if (filterForm.id != undefined) {
        if (item.formId == filterForm.id)
          applied += 1;
      }
      if (filterDateJob != undefined && filterDateJob.trim() != "") {
        let dateJob;
        if (f.workflow.scheduledDate && item.payload.get(f.workflow.scheduledDate)) {
          dateJob = new Date(item.payload.get(f.workflow.scheduledDate).value);
        }
        if (dateJob == undefined || isNaN(dateJob.getTime()))
          dateJob = item._startedAt;
        if (dateJob && dateJob.toISOString().substring(0, 10) == (new Date(filterDateJob)).toISOString().substring(0, 10))
          applied += 1;
      }


      if (applied == qFilterToApply)
        return true;
      return false;
    })
  }
  return (<>
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box safeAreaTop bg="primary.400" />
    <HStack bg="$primary400" px={0} py={0} justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center" maxWidth={statusStore.windowDimensions.width - 140} >
        {leftButton}
        <View style={styles.VStack}>
          <Text style={ styles.headerTitleSection} >
            Permisos de trabajo
          </Text>
          <Text style={ styles.headerSubTitleSection} >ult. sinc.: {new Date(mySubscriptions.lastSync).getYYYYMMddHHmmss()}</Text>
        </View>
      </HStack>
      <HStack>
        <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload"
          onPress={async () => setShowIconInfo(true)}>
          <ButtonIcon as={MaterialCommunityIcons} name="help-circle" fontWeight="$extrabold" size="xl" color="#FFF" />
        </Button>
        <VStack mr={1}>
          {someToUpload > 0 ?
            <Badge h={21} w={22} bg="$red600" borderRadius="$full" mb={-22} mr={0} zIndex={1}
              variant="solid" alignSelf="flex-end" ><BadgeText size="2xs" color="$white" fontWeight="bold">{someToUpload}</BadgeText>
            </Badge> : null
          }
          {mustSync ?
            <Badge h={21} w={22} bg="$yellow600" borderRadius="$full" mb={-22} ml={0} zIndex={1}
              variant="solid" alignSelf="flex-end" ><BadgeText size="2xs" color="$white" fontWeight="bold">!</BadgeText>
            </Badge> : null
          }
          <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload"
            onPress={async () => { Storage.removeItem("must_sync"); await itemsStore.upload({}); formsStore.getSubscriptions(); checkMustSync() }}>
            <ButtonIcon as={MaterialCommunityIcons} name="cloud-sync-outline" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button>
        </VStack>


      </HStack>
    </HStack>

    <VStack bg="white" flex={1}>
      <HStack bgColor={"$black"} px={5} py={1} my={0} justifyContent="center" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"$light300"} >
        <Button.Group isAttached colorScheme="blue" size="sm">
          <Button variant={itemsPending == undefined ? "solid" : "subtle"} onPress={() => setItemsPending(undefined)}>Permisos del Dia</Button>
          <Button variant={itemsPending == true ? "solid" : "subtle"} onPress={() => setItemsPending(true)}>Mis Pendientes</Button>
          <Button variant={itemsPending == false ? "solid" : "subtle"} onPress={() => setItemsPending(false)}>En curso</Button>
        </Button.Group>
        <Spacer></Spacer>
        <Button2 key="btnFilter" borderRadius={0} size="sm" p="$1" marginRight={5} bgColor="$black" onPress={() => setFilterView(true)} >
          <ButtonIcon as={MaterialCommunityIcons} name={qFilterToApply > 0 ? "filter-check" : "filter-outline"} fontWeight="$extrabold" size="xl" color="#FFF" />
        </Button2>
      </HStack>
      <HStack bgColor={"$gray"} px={5} py={1} my={0} justifyContent="center" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"$light300"} >

      </HStack>

      <>
       {my_items.length>0 ? 
        <ItemsListRows />:null}
        <Spacer />
        { itemsPending ?
          <HStack height="$1/3" bgColor="$amber200">
            {Platform.OS == "web" ?
              <MapView defaultZoom={13} region={myLocation} style={{
                width: '100%',
                height: '100%',
              }} >
                <MapView.Marker
                  key="markerUser"
                  icon={svgMarkerUser}
                  title={user.firstName.concat(" ", user.lastName)}
                  description="Tu ubicación"
                  coordinate={myLocation} tracksViewChanges={false}
                />
                {my_items.map((item, idx) => {
                  try {
                    let dept = departments.find(dept => dept.id == item.deptId);
                    if (dept == undefined)
                      return <></>;
                    let form = dept.forms.find(form => form.id == item.formId);
                    if (form == undefined)
                      return <></>;
                    let geoFieldId = form.workflow?.geo;
                    if (geoFieldId && geoFieldId.value != "" && item.payload.get(geoFieldId)?.value != undefined) {
                      const geoElement = item.payload.get(geoFieldId).toJSON()
                      let coords = geoElement.value.coords;
                      if (geoElement.type !== "geo") {
                        let value = geoElement.value.replace("*|", "").replace("OTHER|##", "").replace("##", "");
                        coords = { latitude: parseFloat(value.split(",")[0]), longitude: parseFloat(value.split(",")[1]) }
                      }
                      return <MapView.Marker key={idx}
                        icon={item.statusPTW == "waiting" ? svgMarkerWarning : null}
                        title={getItemTitle(form, item)}
                        description={item.statusPTW}
                        coordinate={coords}
                        onPress={() => {
                          openItem(form, dept, item)
                        }}
                      />
                    } else
                      return null;
                  } catch (e) {
                    console.log("PTWHomeScreen my_items.map", e)
                  }
                })}

              </MapView>
              : //Android
              <MapView style={{
                width: '100%',
                height: '100%',
              }} showsUserLocation={true}
                region={{
                  latitudeDelta: 0.0922,
                  longitudeDelta: 0.0421, ...myLocation
                }}
              >
                {my_items.map((item, idx) => {
                  try {
                    let dept = departments.find(dept => dept.id == item.deptId);
                    if (dept == undefined) return null;
                    let form = dept.forms.find(form => form.id == item.formId);
                    if (form == undefined) return null;

                    let geoFieldId = form.workflow?.geo;
                    if (geoFieldId && geoFieldId.value != "" && item.payload.get(geoFieldId)?.value != undefined) {
                      const geoElement = item.payload.get(geoFieldId).toJSON()
                      let coords = geoElement.value.coords;
                      if (geoElement.type !== "geo") {
                        let value = geoElement.value.replace("*|", "").replace("OTHER|##", "").replace("##", "");
                        coords = { latitude: parseFloat(value.split(",")[0]), longitude: parseFloat(value.split(",")[1]) }
                      }
                      if (coords.latitude == "" || coords.longitude == "" || isNaN(coords.latitude) || isNaN(coords.longitude))
                        return null;
                      else {
                        return <Marker key={idx}
                          pinColor={item.statusPTW == "waiting" ? "orange" : "red"}
                          title={getItemTitle(form, item)}
                          description={item.statusPTW}
                          coordinate={coords} tracksViewChanges={false}
                          onPress={() => {
                            openItem(form, dept, item)
                          }}
                        />
                      }
                    }
                    return null;
                  } catch (e) {
                    console.log("PTWHomeScreen my_items.map", e)
                  }
                })}
              </MapView>}
          </HStack>
          :
          <></>}
        <HStack justifyContent="center">
          <VStack >
            <HStack>
              <Input w={statusStore.windowDimensions.width * 0.7} ml={5} variant="underlined">
                <InputSlot mx={5} >
                  <InputIcon as={SearchIcon} />
                </InputSlot>
                <InputField w="70%" placeholder={"Filtrar por título..."} placeholderTextColor="#8c8c8c" onChangeText={handleSearch} />
              </Input>
              <Spacer />
            </HStack>
            <HStack alignItems={"center"}>
              <Button2 width={50} height={50} p="$1" variant="link" onPress={authenticationStore.signOut}>
                <ButtonIcon as={MaterialIcons} name="logout" fontWeight="$extrabold" size="xl" color="$light500" />
              </Button2>
              <Text style={{color:"#000"}}>{user?.firstName} {user?.lastName}</Text>
              <Button2 width={50} height={50} p="$1" variant="link" onPress={() => navigation.navigate("Settings", { navigateTo: "PTWHome" })}>
                <ButtonIcon as={MaterialIcons} name="settings" fontWeight="$extrabold" size="xl" color="$light500" />
              </Button2>
            </HStack>




          </VStack>
          <Spacer />
          <Button2 margin={2} width={50} height={50} p="$1" borderRadius="$full" variant="solid" bgColor="$green600"
            onPress={() => setSelectNewForm(true)}>
            <ButtonIcon as={Ionicons} name="add" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button2>

          <Actionsheet isOpen={selectNewForm} onClose={() => setSelectNewForm(false)}>
            <ActionsheetBackdrop />
            <ActionsheetContent>
              <ActionsheetDragIndicatorWrapper>
                <ActionsheetDragIndicator />
              </ActionsheetDragIndicatorWrapper>
              <Box w="100%" h={30} px={4} justifyContent="center">
                <Text fontSize={16} color="$secondary900" >
                  Indique permiso de trabajo a crear:
                </Text>
              </Box>
              <ScrollView ><Box w={statusStore.windowDimensions.width - 20} >
                {departments.reduce((lst, dept, idX) => {
                  let forms = [].concat(dept.forms);
                  lst = lst.concat(
                    forms.sort((a, b) => a.name.localeCompare(b.name))
                      .map((f, idY) => <ActionsheetItem py="1" key={"btn_new".concat(idX, "-", idY)} onPress={() => newItem(dept, f)}>
                        <ActionsheetIcon as={MaterialCommunityIcons} name="format-list-checks" />
                        <ActionsheetItemText>{f.name}</ActionsheetItemText>
                      </ActionsheetItem>)
                  );
                  return lst;
                }, [])}</Box></ScrollView><View style={{ height: 20 }} />
            </ActionsheetContent>
          </Actionsheet>
          <Actionsheet isOpen={filterView} onClose={() => setFilterView(false)}>
            <ActionsheetBackdrop />
            <ActionsheetContent>
              <ActionsheetDragIndicatorWrapper>
                <ActionsheetDragIndicator />
              </ActionsheetDragIndicatorWrapper>
              <Box w="100%" h={30} px={4} justifyContent="center">
                <Text fontSize={16} color="$light500" >
                  Filtro sobre la vista actual
                </Text>
              </Box>
              <ScrollView ><Box w={statusStore.windowDimensions.width - 20} >
                <Box>
                  <Text fontSize={16} color="$light500" >
                    Fecha Programada
                  </Text>
                  <DateTimePicker onChange={(v) => { setFilterDateJob(v) }} type={"date"} value={filterDateJob} ></DateTimePicker>
                  <Text fontSize={16} color="$light500" >
                    Formulario
                  </Text>
                  <RNPicker testID="rnpicker-MultipleEl"
                    data={(lstForms.concat({ id: undefined, name: "", f: undefined }) || [])?.map((f, idx) => ({
                      id: f.id
                      , name: f.name, f
                    }))}
                    defaultValue={true}
                    showSearchBar={(lstForms || []).length > 10} searchBarPlaceHolder={"Buscar....."}
                    selectedText={filterForm.name}
                    selectedValue={(index: number, f: { id: string, name: string, f: string }) => setFilterForm({ id: f.id, name: f.name })}
                  />
                  <Text fontSize={16} color="$light500" >
                    Identificador de Registro
                  </Text>
                  <Input w={statusStore.windowDimensions.width - 100} ml={5} variant="underlined">
                    <InputSlot mx={5} >
                      <InputIcon as={GripVerticalIcon} />
                    </InputSlot>
                    <InputField keyboardType="number-pad" w="70%" placeholder="" placeholderTextColor="#8c8c8c" onChangeText={setFilterAutonumeric} />
                  </Input>

                </Box>
              </Box></ScrollView>
            </ActionsheetContent>
          </Actionsheet>
        </HStack>
      </>

    </VStack>
    <ModalInfo alertDialog={alertDialog} setAlertDialog={setAlertDialog} />
    <ModalIconInfo showIconInfo={showIconInfo} setShowIconInfo={setShowIconInfo} statusStore={statusStore} isPTW={true} />  

  </>
  )
})


const styles = StyleSheet.create({
  itemContainer: {
    backgroundColor: glueStyles.colors.white,
    borderBottomColor: glueStyles.colors.light300,
    borderBottomWidth: 1,
    justifyContent: 'center',
    minHeight: 70,
    width: '100%',
  },
  innerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8, 

  },
  contentWrapper: {
    flex: 1,
    marginHorizontal: 10, width:"100%" ,
    justifyContent: 'center', 
    flexBasis: "70%"
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  itemTitle: {
    fontSize: glueStyles.fontSizes.md,
    fontWeight: glueStyles.fontWeights.medium,
    color: glueStyles.colors.light700, // Gray 800
    marginRight: 6,
    flexShrink: 1,
  },
  subInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    widthidth:'100%',
  },
  subText: {
    fontSize: 12,
    color: glueStyles.colors.light500, // Gray 500
  },
  hiddenActionWrapper: {
    alignItems: 'center',
    backgroundColor: glueStyles.colors.light100,
    flexDirection: 'row',
    flex: 1, marginHorizontal: 2
  },
  actionGroup: {
    flexDirection: 'row',
    height: '100%',
  },
  actionButton: {
    width: 55,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 4,flex:1, minWidth: 'auto',
  },
  stepWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 2,
    marginBottom: 2,
  },
  stepArrow: {
    marginHorizontal: 2,
  },
  stepBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 2,
  },
  stepCurrent: {
    backgroundColor: glueStyles.colors.danger500,
  },
  stepSuccess: {
    backgroundColor: glueStyles.colors.success100,
  },
  stepPending: {
    backgroundColor: glueStyles.colors.yellow200,
  },
  stepText: {
    fontSize: 10,
    color: '#666',
  },
  stepTextActive: {
    fontWeight: 'bold',
    color: '#fff',
  },
  headerTitleSection: {
    fontWeight: glueStyles.fontWeights.normal,
    color: '#fff',
    fontSize: glueStyles.fontSizes.lg
  },
  headerSubTitleSection: {
    fontWeight: glueStyles.fontWeights.normal,
    color: '#fff',
    fontSize: glueStyles.fontSizes["2xs"]
  },
  HStack:{
    flexDirection: "row"
  },
  VStack:{
    flexDirection: "column"
  }
});